import { render, staticRenderFns } from "./itemService.vue?vue&type=template&id=360a01c7&scoped=true&"
import script from "./itemService.vue?vue&type=script&lang=js&"
export * from "./itemService.vue?vue&type=script&lang=js&"
import style0 from "./itemService.vue?vue&type=style&index=0&id=360a01c7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "360a01c7",
  null
  
)

export default component.exports